import { defineSaleProgress, isSaleCreated, isSaleSigned, type ProgressSaleData } from '../saleProgress'

interface BillProtectionData extends ProgressSaleData {
  formulaId?: number | string | null
  formulaRank?: number | null
  eligibilityValidated?: boolean
  axaEmailAlreadySent?: boolean
}

export const FORMULA_TERMS: Record<number, { indemnity: string; ceiling: string }> = {
  1: { indemnity: '200 €', ceiling: '2 400 €' },
  2: { indemnity: '300 €', ceiling: '3 600 €' },
}

const PULSE = 'additionalSales:pulse.'
const SALE = 'additionalSales:leadAxaBillProtection.progress.'

export default defineSaleProgress<BillProtectionData>({
  kind: 'sale',
  steps: [
    {
      key: 'eligibility',
      label: `${SALE}eligibility`,
      done: data => !!data.eligibilityValidated || isSaleCreated(data),
    },
    { key: 'documents', label: `${SALE}documents`, done: data => !!data.axaEmailAlreadySent },
    { key: 'created', label: `${PULSE}timeline.created`, done: isSaleCreated },
    { key: 'signature', label: `${PULSE}timeline.signature`, done: isSaleSigned },
  ],
  waitLabel: () => `${PULSE}progress.waiting_signature`,
  formulaId: data => data.formulaId,
  panelValues: (_formula, data) => FORMULA_TERMS[Number(data.formulaRank)] ?? {},
})
